import { createContext } from 'react';

export const PageContext = createContext<{
  slug: string;
  title: string;
  hideSwimlaneTitle: boolean;
  pageId?: string;
} | null>(null);
